import React, { useState, useEffect } from "react";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  ApolloLink,
  gql,
} from "@apollo/client";
import { RestLink } from "apollo-link-rest";
import { HttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
import { connect, useSelector } from "react-redux";
import "./SearchBar.css";
import SearchResults from "./SearchResults";
import { useParams,  } from "react-router-dom";

const SearchGigs = React.memo((props) => {
  const params = useParams();
  // const routerQueryParmas = routerQuery();
  // console.log("routerQueryParmas", routerQueryParmas);
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const [search, setSearch] = useState("");
  const [gigset, setGigSet] = useState();

  const authTokenValue = useSelector(
    (state) => state.authReducer.user.authToken
  );
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const ImpersonationId = useSelector(
    (state) => state.authReducer.impersonationId
  );

  const restLink = new RestLink({
    endpoints: {
      openExchangeRate: "https://open.exchangerate-api.com/v6/",
    },
  });

  const httpLink = new HttpLink({
    uri: `${BackendApiBaseUrl}/guest/skilllisting/search`,
  });

  const authLink = setContext((_, { headers }) => {
    // get the authentication talentToken if it exists
    // return the headers to the context so httpLink can read them
    if (ImpersonationId) {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
          impersonationid: ImpersonationId,
        },
      };
    } else {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
        },
      };
    }
  });

  const client = new ApolloClient({
    // uri: `${BackendApiBaseUrl}/query`,
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
  });

  return (
    <ApolloProvider client={client}>
      <SearchResults
        findMatch={props.findMatch}
        job_title={props.job_title}
        job_id={props.job_id}
        jobdetails={props.jobdetails}
        value={0}
      />
    </ApolloProvider>
  );
});

export default SearchGigs;

// Link: link allows you to customize the flow of data from your graphQL queries
// and mutations to your backend and in-app state management.
// This can include: adding custom headers and routing to REST endpoints and graphQL endpoints.
